<template>
  <div class="fees">
    <p class="fees__title">Informazioni sui costi</p>

    <div class="fees__content">
      <knowbefore-item
        v-for="fee in fees"
        :key="_uid+fee.key"
        :icon="fee.icon"
        :title="fee.name"
      >
        <div class="fees__item" v-html="fee.data" />
      </knowbefore-item>
    </div>
  </div>
</template>

<script>
import { build_data_items } from '@liveeps/utilities'
import KnowBeforeItem from '@liveeps/components/blocks/knowbefore/knowbefore-item'

export default {
  inheritAttrs: false,
  name: 'fees',

  props: {
    property: Object,
  },

  components: {
    'knowbefore-item': KnowBeforeItem,
  },

  data() {
    return {
    }
  },

  computed: {

    // Struttura dati: key, icon, name e content
    fees() {
      const map = [
        { key: 'mandatory', icon: 'euro', name: 'Costi obbligatori' },
        { key: 'optional', icon: 'plus_circle', name: 'Costi opzionali' },
      ]
      return build_data_items(map, this.property)
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

  .fees {
    @extend %section;
    @extend %section_margin;

    &__title {
      display: flex;
      align-items: center;
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      line-height: normal;
    }

    &__content {
      @extend %section__content;
      padding-top: 0;
      padding-bottom: 0;
    }
  }

</style>